import React from 'react';
import { render } from 'react-dom';
import api from './api';
import adminApi from './admin/api';
import App from './App';

Promise.all([
  api.auth.initCurrentUser(),
  adminApi.auth.initCurrentUser(),
])
.then(() => {
  document.querySelector('#app-loader').style.display = "none";
  render(React.createElement(App), document.querySelector('#application'));
});



// WEBPACK FOOTER //
// ./src/frontend/index.js